import { Inject, Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { APP_KEY_NAME, BUYER_NAME } from 'src/app/app.config';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  clean(): void {
    if (typeof localStorage !== 'undefined') localStorage.clear();
  }

  /**
   * Save a particular item to the storage service
   * @param key key of the item to be saved
   * @param value value of the item
   */
  public saveValue(key: string, value: any): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(key);
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  /**
   * Remove a particular item from the storage service
   * @param key key of the item to be removed
   */
  public removeValue(key: string): void {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(key);
  }

  /**
   * Update an existing item in the storage service
   * @param key key of the item to be updated
   * @param value value of the item
   */
  public updateValue(key: string, value: any): void {
    if (typeof localStorage !== 'undefined') {
      let old_value = this.getValue(key);
      if (old_value) {
        old_value = { ...old_value, ...value };
        this.saveValue(key, old_value);
      } else this.saveValue(key, value);
    }
  }

  /**
   * Get the item from the storage service
   * @param key key of the item to be retrieved
   * @returns the value of the item
   */
  public getValue(key: string): any {
    if (typeof localStorage !== 'undefined') {
      const value = localStorage.getItem(key);
      if (value) return JSON.parse(value);
      return null;
    } else return null;
  }

  public getAppKey(): string | null {
    return this.getCookie(APP_KEY_NAME);
  }

  public removeUID(): void {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(BUYER_NAME);
  }

  public setUID(item: string): null {
    if (typeof localStorage !== 'undefined') {
      const value = localStorage.setItem(BUYER_NAME, JSON.stringify(item));
    }
    return null;
  }

  public getUID(): string  {
    if (typeof localStorage !== 'undefined') {
      const value = localStorage.getItem(BUYER_NAME);
      if (value) return JSON.parse(value);
      return '';
    } else return '';
  }

  /**
   * Returns the UID as a URL prefix (e.g. '/abc123'), or '' if no UID is stored.
   * Use to prefix route segments when navigating programmatically.
   */
  public getUidPrefix(): string {
    const uid = this.getUID();
    return uid ? '/' + uid : '';
  }

  public getCookie(name: string): string | null {
    if (typeof document !== 'undefined') {
      let ca: Array<string> = document.cookie.split(';');
      let caLen: number = ca.length;
      let cookieName = `${name}=`;
      let c: string;

      for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
          return c.substring(cookieName.length, c.length);
        }
      }
    }
    return null;
  }
}
